import { Center } from "@/components/Center/Center";
import { useHandleError } from "@/hooks/useHandleError";
import { usePointWithdrawals } from "@/hooks/usePointWithdrawals";
import { useTotalWithdrawals } from "@/hooks/useTotalWithdrawals";
import { getAuthenticatedUser } from "@/store/auth.store";
import { pointsToYen } from "@/utils/pointsToYen";
import LoadingSpinner from "@roman/shared/components/LoadingSpinner";
import { RecordCard } from "./Card";

export const WithdrawalRecord = () => {
  const handleError = useHandleError("ポイント履歴の取得に失敗しました");
  const { data: records, isLoading } = usePointWithdrawals(handleError);
  const { data: totalWithdrawals, isLoading: isTotalWithdrawalsLoading } = useTotalWithdrawals(handleError);
  const user = getAuthenticatedUser();

  if (isLoading || !records || isTotalWithdrawalsLoading || !totalWithdrawals) {
    return (
      <Center>
        <LoadingSpinner />
      </Center>
    );
  }

  return (
    <div className="bg-white min-w-full min-h-screen">
      <div className="p-[18px] flex flex-col items-start gap-10">
        <div className="flex flex-col items-start gap-3 w-full">
          <div className="flex items-center gap-3">
            <p className="text-xl font-bold -tracking-[.01em] text-black">ポイント履歴</p>
          </div>

          <div className="flex flex-col items-start gap-[26px] w-full bg-[#EFF9FF] rounded-md">
            <div className="flex items-center justify-between py-4 px-6 w-full">
              <div className="flex flex-col items-start gap-1.5 w-full">
                <div className="flex flex-col items-start gap-1.5 border-b border-primary border-dashed w-full pb-3">
                  <p className="text-xs font-semibold -tracking-[.01em] text-black">残高</p>
                  <p className="text-lg font-medium -tracking-[.01em] text-primary">
                    <span className="text-[32px] font-bold mr-1">{pointsToYen(user.redeemablePoints)}</span>円分
                  </p>
                  <p className="text-xs font-semibold -tracking-[.01em] text-gray">
                    ≒{Number(user.redeemablePoints).toLocaleString()}ポイント
                  </p>
                </div>

                <div className="flex flex-col items-start w-full pt-3">
                  <p className="text-xs font-semibold -tracking-[.01em] text-gray">累計の出金総額</p>
                  <p className="text-sm font-semibold -tracking-[.01em] text-black">
                    {pointsToYen(totalWithdrawals.totalWithdrawnPoints)}円
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 w-full">
          {records.map((record, index) => {
            return <RecordCard key={index} record={record} />;
          })}
        </div>
      </div>
    </div>
  );
};
